import { render, staticRenderFns } from "./ExamineDia.vue?vue&type=template&id=08f2ba46&scoped=true"
import script from "./ExamineDia.vue?vue&type=script&lang=js"
export * from "./ExamineDia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f2ba46",
  null
  
)

export default component.exports